import styled from 'styled-components';
import query from '../../../const/mediaQueries';
import { colors, consumerTheme, fontSizes, fontWeights } from '../../../defaultTheme';
export const StepBase = styled.ol `
  display: flex;
  flex-direction: row;
  position: relative;
  padding: 0;
  margin: 0 auto;
  @media ${query.lessThanSmall} {
    margin: 0;
  }
`;
export const StepList = styled.li `
  display: flex;
  flex: 1;
  flex-direction: column;
  list-style-type: none;
  font-family: 'Open Sans';
  font-size: ${fontSizes.small}px;
  align-items: center;
  position: relative;
  margin: 0;

  &:after {
    position: absolute;
    content: '';
    width: 100%;
    z-index: -1;
    top: ${({ circleRadius }) => circleRadius * 2.5}px;
    left: 50%;
    ${({ isCompleted, circleRadius }) => isCompleted
    ? `
        border-bottom: ${circleRadius}px solid ${consumerTheme.progressStepBar.fill};
        `
    : `
        border-bottom: ${circleRadius}px solid ${colors.pattensBlue};

        `};
  }

  &:last-child::after {
    content: none;
  }
`;
export const StepNode = styled.span `
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: ${({ circleRadius }) => circleRadius * 4}px;
  height: ${({ circleRadius }) => circleRadius * 4}px;
  border-radius: 50%;
  margin-bottom: ${({ circleRadius }) => circleRadius + 2}px;
  border: ${({ circleRadius }) => circleRadius}px solid ${colors.pattensBlue};
  background: ${colors.white};
  ${({ isActive, isLastStep, circleRadius }) => isActive && !isLastStep
    ? `
         box-shadow: 0 0 0 ${circleRadius + 2}px ${consumerTheme.progressStepBar.fill};
        border: ${circleRadius}px solid ${consumerTheme.progressStepBar.fill};
         background-color: ${colors.white};
       `
    : `
         border: ${circleRadius}px solid ${colors.pattensBlue};
         
       `};

  ${({ isCompleted, isLastStep, circleRadius }) => isCompleted || isLastStep
    ? `
        border: ${circleRadius}px solid ${consumerTheme.progressStepBar.fill};
        background-color: ${consumerTheme.progressStepBar.fill};
       
        color:${colors.white};
        `
    : ''}

  ${({ onClick, isCompleted, isActive, theme }) => onClick &&
    `
      &:hover:before {
        box-shadow: 0 0 1px 4px
          ${isCompleted || isActive
        ? theme.progressStepBar.hover
        : 'transparent'};
      }
      &:hover {
        cursor: pointer;
        color: ${colors.black};
      }
    `}
`;
export const StepLabel = styled.span `
  overflow-wrap: anywhere;
  padding: 0 4px;
  margin-top: ${({ circleRadius }) => circleRadius * 2.5}px;
  font-weight: ${({ isActive }) => isActive ? fontWeights.bold : fontWeights.regular};
`;
export const NonVisualInfo = styled.span `
  position: absolute;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
`;
